/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProjectResponseDashboardDto } from '../../models/project-response-dashboard-dto';

export interface DashboardProjectsControllerGetProjectV1$Params {
  id: string;
}

export function dashboardProjectsControllerGetProjectV1(http: HttpClient, rootUrl: string, params: DashboardProjectsControllerGetProjectV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ProjectResponseDashboardDto>> {
  const rb = new RequestBuilder(rootUrl, dashboardProjectsControllerGetProjectV1.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProjectResponseDashboardDto>;
    })
  );
}

dashboardProjectsControllerGetProjectV1.PATH = '/v1/dashboard/projects/{id}';
